var map = {
	"./abstract01.webp": 2384,
	"./abstract010.webp": 2385,
	"./abstract02.webp": 2386,
	"./abstract03.webp": 2387,
	"./abstract05.webp": 2388,
	"./abstract06.webp": 2389,
	"./abstract07.webp": 2390,
	"./big_head_-1.webp": 2391,
	"./big_head_-10.webp": 2392,
	"./big_head_-2.webp": 2393,
	"./big_head_-3.webp": 2394,
	"./big_head_-5.webp": 2395,
	"./big_head_-6.webp": 2396,
	"./big_head_-7.webp": 2397,
	"./small_head_-1.webp": 2398,
	"./small_head_-10.webp": 2399,
	"./small_head_-2.webp": 2400,
	"./small_head_-3.webp": 2401,
	"./small_head_-5.webp": 2402,
	"./small_head_-6.webp": 2403,
	"./small_head_-7.webp": 2404,
	"./sponsor-banner-cn-m.webp": 2405,
	"./sponsor-banner-cn.webp": 2406,
	"./sponsor-banner-id-m.webp": 2407,
	"./sponsor-banner-id.webp": 2408,
	"./sponsor-banner-m.webp": 2409,
	"./sponsor-banner-ms-m.webp": 2410,
	"./sponsor-banner-ms.webp": 2411,
	"./sponsor-banner.webp": 2412,
	"./sponsor-bg-1-cn.webp": 2413,
	"./sponsor-bg-1-id.webp": 2414,
	"./sponsor-bg-1-ms.webp": 2415,
	"./sponsor-bg-1.webp": 2416,
	"./sponsor-bg-2-cn.webp": 2417,
	"./sponsor-bg-2-id.webp": 2418,
	"./sponsor-bg-2-ms.webp": 2419,
	"./sponsor-bg-2.webp": 2420,
	"./sponsor-bg-m-2-cn.webp": 2421,
	"./sponsor-bg-m-2-id.webp": 2422,
	"./sponsor-bg-m-2-ms.webp": 2423,
	"./sponsor-bg-m-2.webp": 2424,
	"./sponsor-video-one.mp4": 2425
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2383;